import { render, staticRenderFns } from "./bank.svg.vue?vue&type=template&id=0e3e1242&"
import script from "./bank.svg.vue?vue&type=script&lang=js&"
export * from "./bank.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports